<template>
    <div>
    <!-- filepath: d:\FE-VM\vueFEVimassHome\src\views\Vimass\Home\ChiTietBaiViet.vue -->
<button class="scroll-to-top-btn" @click="scrollToTop">
  ⬆
</button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showButton: false,
        };
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.showButton = window.scrollY > 200;
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
    },
};
</script>

<style scoped>
.scroll-to-top-btn {
  position: fixed;
  right: 24px;
  bottom: 32px;
  z-index: 999;
  background: linear-gradient(90deg, #007abb 60%, #1ecbe1 100%);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 28px;
  font-weight: bold;
  box-shadow: 0 4px 16px rgba(23,106,148,0.18);
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
}
.scroll-to-top-btn:hover {
  background: #1ecbe1;
  transform: scale(1.1);
}
</style>